let fallbackUid = 0;

export const generateOverlayUid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  fallbackUid += 1;
  return `overlay-${Date.now().toString(36)}-${fallbackUid.toString(36)}`;
};

export const createOverlayRegistry = (Vue) => {
  const state = Vue.observable({ items: [] });

  const get = (id) => state.items.find((item) => item.id === id);
  const remove = (id) => {
    const index = state.items.findIndex((item) => item.id === id);
    if (index === -1) return false;
    state.items.splice(index, 1);
    return true;
  };

  return {
    add(item) {
      state.items.push(item);
      return item.id;
    },
    list: () => state.items,
    get,
    has: (id) => !!get(id),
    close(id) {
      const item = get(id);
      if (!item || !item.state) return false;
      item.state = false;
      return true;
    },
    remove,
    resetAll() {
      if (!state.items.length) return false;
      state.items.splice(0, state.items.length);
      return true;
    },
  };
};
